var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowScore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5598 1.27114L8.19579 7.67705C7.75829 8.11744 7.01954 8.11744 6.58204 7.67705L0.217951 1.27114C-0.260189 0.789797 0.0999838 0 0.797664 0H13.9801C14.6778 0 15.038 0.789797 14.5598 1.27114Z",
    fill: "#2B3779"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowScore);
export default __webpack_public_path__ + "static/media/arrowScore.6496bcbb18cb79f8fbf8a0fa27485a75.svg";
export { ForwardRef as ReactComponent };